"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _fp = require("lodash/fp");
var _geteligiblerewards = /*#__PURE__*/ _interop_require_default(require("../get-eligible-rewards"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isEligible = function(offer, param) {
    var productId = param.productId, scale = param.scale;
    return !(0, _fp.isEmpty)((0, _geteligiblerewards.default)(offer, {
        productId: productId,
        scale: scale
    }));
};
var _default = isEligible;
